import Vue from "vue";
import axios from "axios";
import {
  Loading
} from "element-ui";

import store from "@/store/store.js";
import { ApiUrl, load } from "./api";

Vue.use(store);

Vue.prototype.$axios = axios;

//深拷贝
export function deepclone(obj) {
  var _obj = JSON.stringify(obj),
    objclone = JSON.parse(_obj);
  return objclone;
}

export function getCurrentMonthLast(date) {
  var currentMonth = date.getMonth();
  var nextMonth = ++currentMonth;
  var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
  var oneDay = 1000 * 60 * 60 * 24;
  var lastTime = new Date(nextMonthFirstDay - oneDay);
  var month = parseInt(lastTime.getMonth() + 1);
  var day = lastTime.getDate();
  if (day < 10) {
    day = "0" + day;
  }
  return day;
}
//处理时间
export function FormatToDate(time) {
  var date = new Date(time);
  return formatDate(date, "yyyy-MM-dd hh:mm:ss");
}

//处理时间
export function DisposeTime(time) {
  if (time == null) return "---";
  var date = new Date(time);
  return formatDate(date, "yyyy-MM-dd hh:mm");
}

//处理个性化设置上下班时间
export function FormatWorkTime(time) {
  var date = new Date(time);
  return formatDate(date, "hh:mm");
}

//编辑班次时，数据库取到的0001-01-01 hh:mm:ss时间的处理
export function FormatShiftTime(time) {
  var nowtime = new Date();
  var date = new Date(time);
  var str1 = formatDate(nowtime, "yyyy-MM-dd");
  var str2 = formatDate(date, "hh:mm:ss");
  return new Date(str1 + "T" + str2);
}

export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  var o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds()
  };
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      var str = o[k] + "";
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
      );
    }
  }
  return fmt;
}

export function IsEmpty(val) {
  if (typeof val != "undefined" && val != null && val != "") {
    return false;
  } else {
    return true;
  }
}

//下载模板
export function download(url, filename, params, status) {
  // store.state.fullscreenLoading = true;
  if (status) {
    var occlusion = Vue.prototype.$message({
      showClose: true,
      message: "正在加载中",
      type: "success",
      center: true
    });
  }

  axios({
      method: "get",
      url: url,
      params: params,
      responseType: "blob",
      onDownloadProgress(progress) {
        store.state.progressNum = 0;
        store.state.progressNum = Math.round(
          (progress.loaded / progress.total) * 100
        );
        if (store.state.progressNum < 2) {
          store.state.progressNum = 2;
        }
        if (store.state.progressNum == 100) {
          setTimeout(() => {
            store.state.progressNum = 0;
            store.state.downloadStatus = false;
          }, 1000);
        }
      }
    })
    .then(function (res) {
      if (status) {
        setTimeout(function () {
          occlusion.close();
        }, 300);
      }
      if (!res.data) {
        return;
      }
      var blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
      }); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement("a");
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.href = href;
      downloadElement.download = filename + ".xlsx"; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    })
    .catch(error => {
      store.state.downloadStatus = false;

      if (status) {
        setTimeout(function () {
          occlusion.close();
        }, 300);
      }
    });
}

//下载模板
export function downloads(
  url,
  filename,
  params,
  data,
  status,
  customFileLoading
) {
  if (status) {
    var occlusion = Vue.prototype.$message({
      showClose: true,
      message: "正在加载中",
      type: "success",
      center: true
    });
  }
  if (customFileLoading) {
    store.state.customFileLoading = true;
  }
  axios({
      method: "post",
      url: url,
      params: params,
      data: data,
      responseType: "blob"
    })
    .then(function (res) {
      store.state.fullscreenLoading = false;
      if (status) {
        setTimeout(function () {
          occlusion.close();
        }, 300);
      }
      if (!res.data) {
        return;
      }
      if (customFileLoading && !store.state.customFileLoading) {
        return;
      }
      var blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
      }); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement("a");
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.href = href;
      downloadElement.download = filename + ".xlsx"; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象

      if (customFileLoading) {
        setTimeout(function () {
          store.state.customFileLoading = false;
        }, 300);
      }
    })
    .catch(error => {
      store.state.fullscreenLoading = false;
      store.state.customFileLoading = false;
      occlusion.close();
      // if (status) {
      //   setTimeout(function() {
      //     occlusion.close();
      //   }, 300);
      // }
    });
}

// axios调用封装
export async function axiosApply(
  method,
  url,
  params,
  data,
  sueecssFeedback,
  failedFeedback,
  ifFullScreenLoading
) {
  let loadingInstance = null;
  if (ifFullScreenLoading) {
    loadingInstance = Vue.prototype.$loading({
      fullscreen: true
    });
  }
  try {
    let res = await axios({
      method: method,
      url: url,
      params: params,
      data: data
    });
    if (res.status == 200) {
      sueecssFeedback(res);
    } else {
      failedFeedback(res);
    }
    loadingInstance.close();
  } catch (e) {
    console.log(e);
    loadingInstance.close();
  }
}

export function conStatusHandle() {
  return new Promise((resolve, reject) => {
    store.dispatch('getUserInfo');

    // console.log(store.state)
    //    // 在页面加载时读取sessionStorage里的状态信息
    //    if (sessionStorage.getItem('store')) {
    //     store.replaceState(
    //       Object.assign(
    //         {},
    //         store.state,
    //         JSON.parse(sessionStorage.getItem('store'))
    //       )
    //     )
    //   }

    //   // 页面刷新时，将vuex里的信息保存到sessionStorage
    //   // 在页面刷新时先触发beforeunload事件
    //   window.addEventListener('beforeunload', () => {
    //     sessionStorage.setItem('store', JSON.stringify(store.state))
    //   })
    // console.log(store.state)
    let _this = this;
    load("Get", ApiUrl.getCompanyCertOrSimpleInfo, function(res) {
      let result = res.data;
      _this.companyAuthInfo = result;
      if(result.isSuccess){
        if(result.data.processStatus != 3){
          _this.confirmText = '去认证';
          _this.contractDialog.show = true;
          resolve(true)
          return;
        } else {
          load("Get", ApiUrl.reqGetStatus + "?type=9", function(res) {
            let result = res.data;
            if(result.code == 200){
              let status = result.data.status;
              if (status == 0) {
                _this.confirmText = '联系客服';
                _this.contractDialog.show = true;
                resolve(true)
              } else if (status == 2) {
                _this.confirmText = '去签署';
                _this.contractDialog.show = true;
                resolve(true)
              } else if (status == 3) {
                _this.confirmText = '去续签';
                _this.contractDialog.show = true;
                resolve(true)
              } else {
                resolve(false)
              }
              store.commit('set_status', result);
            }
          })
        }
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js